exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rankHead[data-v-1a485752]{height:35%}.songList[data-v-1a485752]{top:46%;z-index:11}.plistText[data-v-1a485752]{width:100%;background:rgba(0,0,0,.5);position:absolute;z-index:11;color:#fff;bottom:0;left:0;padding:10px 20px;box-sizing:border-box;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-1a485752","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/singer_info.vue
// module id = 42
// module chunks = 0